// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1ajuY","errorLogs":"EditorFooter_errorLogs__2pgY0"};